import PropTypes from 'prop-types'
import { Typography } from '../styled'
import theme from '../../constants/theme'
import AbstractForm from '../forms/AbstractForm'
import { convertCamelToStartCase } from '../../utilities/stringUtilities'

function MultiChoiceQuestion({ question, index, setEliminatingAnswers }) {
  const answerOptions = question.answer?.options || question.answer || {}

  const inputs = [
    {
      name: `multiChoice`,
      label: `Q${index}: ${question.question}`,
      renderType: 'radio',
      type: 'checkbox',
      required: true,
      options: Object.keys(answerOptions).map((a) => ({
        label: convertCamelToStartCase(a),
        value: a,
      })),
      width: 12,
    },
  ]

  const handleFormWatch = (value) => {
    if (value.multiChoice !== undefined) {
      const answerValue = Array.isArray(value.multiChoice)
        ? value.multiChoice.reduce(
            (accumulator, v) => ({ ...accumulator, [v]: true }),
            {},
          )
        : value.multiChoice

      setEliminatingAnswers((prev) => [
        ...prev.filter((a) => a.id !== question.id),
        {
          id: question.id,
          answer: answerValue,
        },
      ])
    }
  }

  return (
    <>
      {' '}
      <p className="mt-4 mb-3">
        <Typography
          size={14}
          bold
          style={{
            backgroundColor: theme.talentinoWhiteBlue,
            color: theme.brandColorOrange,
            borderRadius: '50%',
            padding: '6px',
          }}
        >
          {`Q${index}`}
        </Typography>{' '}
        <Typography
          backgroundColor={theme.cardBorder}
          color={theme.inputField}
          className="mx-1"
        >
          {question.question}
        </Typography>
      </p>
      <AbstractForm
        inputs={inputs}
        handleFormWatch={(value) => handleFormWatch(value)}
      />
    </>
  )
}

export default MultiChoiceQuestion

MultiChoiceQuestion.defaultProps = {
  setEliminatingAnswers: () => {},
  index: 0,
  question: PropTypes.shape({
    id: '',
    question: '',
    answer: {},
  }),
}

MultiChoiceQuestion.propTypes = {
  setEliminatingAnswers: PropTypes.func,
  index: PropTypes.number,
  question: PropTypes.shape({
    id: PropTypes.string.isRequired,
    question: PropTypes.string.isRequired,

    // eslint-disable-next-line react/forbid-prop-types
    answer: PropTypes.object.isRequired,
  }),
}
